import { Link } from "react-router-dom";
import { Film } from "lucide-react";

// Shown while no real indie films exist yet — teases the upcoming Indie Spotlight feature.
export default function IndieTeaser() {
  return (
    <section className="px-4 lg:px-14 py-8" data-testid="indie-teaser">
      <div className="rounded-[var(--card-radius)] border border-dashed border-[var(--border-accent)] bg-[var(--bg-card)] p-6 text-center sm:p-8">
        <div className="inline-flex items-center gap-2 rounded-full bg-[color:var(--accent)]/15 px-3 py-1 text-xs font-bold uppercase tracking-[0.22em] text-[var(--accent-hover)]">
          <Film size={14} /> Coming soon
        </div>
        <h2 className="mt-3 font-head text-2xl sm:text-3xl text-[var(--text-primary)]">Indie Spotlight</h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-relaxed text-[var(--text-secondary)]">
          We're making room for independent filmmakers on The Dial. Soon you'll discover hand-picked indie films right here — with links to watch them directly from their creators.
        </p>
        <a href="/submit" className="mt-5 inline-flex items-center gap-2 rounded-[var(--card-radius)] border border-[var(--accent)] px-5 py-2.5 text-sm font-bold uppercase tracking-wide text-[var(--accent-hover)] transition-colors hover:bg-[var(--accent)] hover:text-[var(--accent-contrast)]" data-testid="teaser-submit-link">
          Submit your film
        </a>
        <Link to="/creators" className="mt-3 block text-xs font-semibold text-[var(--text-secondary)] underline underline-offset-4 hover:text-[var(--accent-hover)]" data-testid="indie-how-it-works">How it works</Link>
      </div>
    </section>
  );
}
